module.exports = __webpack_public_path__ + "static/media/3_r_monitor_51.35_92.22.327aa3a5.png";